/**
 * 输入框字符过滤（键入即生效）
 *
 * ★ 与「表单校验」的分工：
 *   本文件只负责**挡住明显不该输入的字符**（例如手机号框里打进汉字）；
 *   「格式是否完整合法」仍由 el-form 的 rules 负责，两者不要混用。
 *
 * ★ 只过滤用户键入的内容，**不主动清洗已加载的数据**：
 *   编辑一条历史数据时，若该字段存有脏字符，只要用户不改它就不会被静默改写。
 *
 * 用法：
 *   <el-input v-model="queryParams.mobile" @input="(v: string) => (queryParams.mobile = onlyDigits(v))" />
 */

/** 纯数字：手机号、邮编、QQ 号等 */
export const onlyDigits = (value: unknown): string => {
  if (value === null || value === undefined) {
    return ''
  }
  return String(value).replace(/\D/g, '')
}

/**
 * 电话：数字 + 常见电话符号（`-` `+` `(` `)` 空格）
 *
 * ⚠️ 不要收紧成纯数字。座机普遍写作 `010-12345678`、`400-800-8888`、
 *    `+86-25-12345678`，若限制成数字，用户就搜不到正确数据 ——
 *    那等于把「不能填汉字」修成了「不能填座机」，是反向 bug。
 */
export const onlyPhone = (value: unknown): string => {
  if (value === null || value === undefined) {
    return ''
  }
  return String(value).replace(/[^0-9+\-() ]/g, '')
}

/**
 * IP：只保留 IPv4 / IPv6 可能用到的字符（`0-9` `a-f` `.` `:`）
 *
 * ⚠️ 会连 `/` 一起拦掉 ⇒ CIDR（`192.168.1.0/24`）、带端口（`1.2.3.4:8080`）、
 *    带协议（`http://1.2.3.4`）都打不进去。IP 字段的语义是「单个地址」，
 *    带端口/网段应另开字段，所以这里是刻意的，不是漏了。
 * ⚠️ 与之配套的规则是 `formRules.ts` 的 `ipAddress()`：本函数只管「字符集」，
 *    「是不是一个合法地址」交给 rules（分工见文件头注释）。
 * ⚠️ 不支持 IPv6 zone id（`fe80::1%eth0`）—— 同 `ipAddress()` 的取舍，`%` 会被拦掉。
 */
export const onlyIpChars = (value: unknown): string => {
  if (value === null || value === undefined) {
    return ''
  }
  return String(value).replace(/[^0-9a-fA-F:.]/g, '')
}
